  <!-- 新建承运商档案 -->
<template>
  <div id="NVOCC_create">
    <div class="NVOCC_title">
      <div v-for="(item, index) in options" :key="index" :class="{ activeItem: currentTab === item.tabModName }" @click="itemClick(item.tabModName)">
        <span>{{ item.tabName }}</span>
      </div>
    </div>
    <component :is="currentTab" :common="commonProp" @RELOADPAGE="reloadpage" />
  </div>
</template>
<script >
import baseinfo from "@/pages/Customers/NVOCCMODRX/BaseInfo.vue";

export default {
  inject: ["reload"],
  components: {
    baseinfo,
  },

  data() {
    return {
      options: [
        {
          tabName: "基础信息",
          tabModName: "baseinfo",
        },
      ],
      currentTab: "baseinfo",
      commonProp: {
        carrierId: null,
      },
    };
  },

  created() {},

  methods: {
    itemClick(tab) {
      this.currentTab = tab;
    },
    reloadpage() {
      this.$TOOLS.closePage();
      this.$router.push({
        path: "/Customers/NVOCC",
        query: {
          isreload: "isreload",
        },
      });
    },
  },
};
</script>
<style scoped lang="less">
.NVOCC_title {
  background: rgba(0, 0, 0, 0.08);
  color: rgba(0, 0, 0, 0.802);
  display: flex;
  div {
    padding: 10px 26px;
    cursor: pointer;
  }
  .activeItem {
    background: #fff;
    border-bottom: rgb(229, 49, 49) 2px solid;
  }
}
</style>
